function kz(number, options = {}) {
    return { tag: `KZ${number}`, value: { kind: 'kz', kz: number, ...options } };
}
const add = (number, options = {}) => kz(number, { effect: 'add', ...options });
const subtract = (number) => kz(number, { effect: 'subtract' });
// --- U1 ----------------------------------------------------------------------
const U1_2025 = [
    {
        tag: 'LIEFERUNGEN_LEISTUNGEN_EIGENVERBRAUCH',
        children: [
            // Prüfung U1: "KZ 000 muss vorhanden sein. Der Wert Null ist zulässig."
            kz('000', { nonNegative: true, always: true }),
            kz('001'),
            kz('021'),
            {
                tag: 'STEUERFREI',
                children: [
                    kz('011'),
                    kz('012'),
                    kz('015'),
                    kz('017'),
                    kz('018'),
                    kz('019'),
                    kz('016'),
                    // Prüfung U1: KZ 020 nur zusammen mit VST (Ziffer des § 6 Abs 1).
                    { tag: 'VST', value: { kind: 'text', key: 'vst' } },
                    kz('020'),
                ],
            },
            {
                tag: 'VERSTEUERT',
                children: [
                    kz('022'),
                    kz('029'),
                    kz('006'),
                    kz('037'),
                    kz('052'),
                    kz('007'),
                    kz('056'),
                    kz('057'),
                    kz('048'),
                    kz('044'),
                    kz('032'),
                ],
            },
        ],
    },
    {
        tag: 'INNERGEMEINSCHAFTLICHE_ERWERBE',
        children: [
            kz('070'),
            kz('071'),
            {
                tag: 'VERSTEUERT_IGE',
                children: [kz('072'), kz('073'), kz('008'), kz('088'), kz('076'), kz('077')],
            },
        ],
    },
    {
        tag: 'VORSTEUER',
        children: [
            kz('060'),
            kz('061'),
            kz('083'),
            kz('065'),
            kz('066'),
            kz('082'),
            kz('087'),
            kz('089'),
            kz('064'),
            kz('062'),
            kz('063'),
            kz('067'),
            kz('090'),
        ],
    },
];
// --- E1 mit E1a ----------------------------------------------------------------
/** `<EINZELUNTERNEHMER>` = the Beilage E1a. */
const E1A_2025 = {
    tag: 'EINZELUNTERNEHMER',
    children: [
        {
            tag: 'ALLGEMEIN',
            children: [
                { tag: 'ADR_BETR', value: { kind: 'text', key: 'adresse' } },
                { tag: 'PLZ_BETR', value: { kind: 'text', key: 'plz' } },
                { tag: 'ORT_BETR', value: { kind: 'text', key: 'ort' } },
                { tag: 'STAAT_BETR', value: { kind: 'text', key: 'staat' } },
                { tag: 'BRKZ', value: { kind: 'text', key: 'branchenkennzahl' } },
                // Exactly one Gewinnermittlungsart; which one comes from `gewinnermittlung`.
                { tag: 'GWA43', value: { kind: 'flag', when: 'gewinnermittlung' } },
                { tag: 'GWA171', value: { kind: 'flag', when: 'gewinnermittlung' } },
                // Prüfung E1a: bei § 4 Abs 3 und § 17 Abs 1 muss Brutto- oder
                // Nettosystem gewählt sein. easyrechnung bucht netto (`reports/ear.ts`).
                { tag: 'GWAUSTN', value: { kind: 'flag', when: 'ust_nettosystem' } },
            ],
        },
        {
            tag: 'ERTRAEGE_EINNAHMEN',
            children: [
                // Prüfung E1a: 9040 oder 9050 muss vorhanden sein, 0 ist gültig.
                add('9040', { always: true }),
                add('9050'),
                add('9060'),
                add('9090'),
                add('9093'),
            ],
        },
        {
            tag: 'AUFWENDUNGEN_AUSGABEN',
            children: [
                subtract('9100'),
                subtract('9110'),
                subtract('9120'),
                subtract('9130'),
                subtract('9134'),
                subtract('9135'),
                subtract('9150'),
                subtract('9160'),
                subtract('9165'),
                subtract('9170'),
                subtract('9180'),
                subtract('9190'),
                subtract('9200'),
                subtract('9210'),
                subtract('9275'),
                subtract('9215'),
                subtract('9216'),
                subtract('9217'),
                subtract('9220'),
                subtract('9225'),
                subtract('9244'),
                subtract('9245'),
                subtract('9246'),
                subtract('9209'),
                subtract('9230'),
                subtract('9233'),
                subtract('9259'),
            ],
        },
        {
            tag: 'GEWINN_VERLUST',
            children: [
                subtract('9276'),
                subtract('9277'),
                subtract('9344'),
                subtract('9345'),
                add('9337'),
                add('9260'),
                add('9270'),
                add('9280'),
                add('9010'),
                add('9290'),
                subtract('9221'),
                { tag: 'GRUNDFB', value: { kind: 'flag', when: 'grundfreibetrag_verzicht' } },
                subtract('9227'),
                subtract('9229'),
                add('9234'),
                add('9020'),
                subtract('9021'),
            ],
        },
    ],
};
const EINKUNFTSART_2025 = {
    selbstaendig: { block: 'EINKUENFTE_SELBST_ARBEIT', result: 'KZ320' },
    gewerbebetrieb: { block: 'EINKUENFTE_GEWERBEBETRIEB', result: 'KZ330' },
};
function e1Tree(einkunftsart) {
    const { block, result } = EINKUNFTSART_2025[einkunftsart];
    return [
        {
            tag: 'BETRIEBLICHE_EINKUNFTSARTEN',
            children: [
                {
                    tag: block,
                    children: [
                        E1A_2025,
                        {
                            tag: 'EINKUNFTSVERTEILUNG',
                            children: [{ tag: result, value: { kind: 'amount', key: 'einkuenfte' } }],
                        },
                    ],
                },
            ],
        },
        {
            tag: 'SONDERAUSGABEN_VERLUSTABZUG',
            children: [{ tag: 'KZ462', value: { kind: 'amount', key: 'verlustabzug' } }],
        },
    ];
}
/** XSD enumeration of `BRKZ` 2025 (ÖNACE 2025), sorted. */
// prettier-ignore
const BRANCHENKENNZAHLEN_2025 = [
    '011', '012', '013', '014', '015', '016', '017', '021', '022', '023', '024', '031', '032', '033',
    '051', '052', '061', '062', '071', '072', '081', '089', '091', '099', '101', '102', '103', '104',
    '105', '106', '107', '108', '109', '110', '120', '131', '132', '133', '139', '141', '142', '151',
    '152', '161', '162', '171', '172', '181', '182', '191', '192', '201', '202', '203', '204', '205',
    '206', '211', '212', '221', '222', '231', '232', '233', '234', '235', '236', '237', '239', '241',
    '242', '243', '244', '245', '251', '252', '253', '254', '255', '256', '259', '261', '262', '263',
    '264', '265', '266', '267', '271', '272', '273', '274', '275', '279', '281', '282', '283', '284',
    '289', '291', '292', '293', '301', '302', '303', '304', '309', '310', '321', '322', '323', '324',
    '325', '329', '331', '332', '351', '352', '353', '354', '360', '370', '381', '382', '383', '390',
    '410', '421', '422', '429', '431', '432', '433', '434', '435', '436', '439', '461', '462', '463',
    '464', '465', '466', '467', '468', '469', '471', '472', '473', '474', '475', '476', '477', '478',
    '479', '491', '492', '493', '494', '495', '501', '502', '503', '504', '511', '512', '521', '522',
    '523', '531', '532', '533', '551', '552', '553', '554', '559', '561', '562', '563', '564', '581',
    '582', '591', '592', '601', '602', '603', '611', '612', '619', '621', '622', '629', '631', '639',
    '641', '642', '643', '649', '651', '652', '653', '661', '662', '663', '681', '682', '683', '691',
    '692', '701', '702', '711', '712', '721', '722', '731', '732', '733', '741', '742', '743', '749',
    '750', '771', '772', '773', '774', '775', '781', '782', '791', '799', '800', '811', '812', '813',
    '821', '822', '823', '824', '829', '841', '842', '843', '851', '852', '853', '854', '855', '856',
    '861', '862', '869', '871', '872', '873', '879', '881', '889', '901', '902', '903', '911', '912',
    '913', '914', '920', '931', '932', '941', '942', '949', '951', '952', '953', '954', '961', '962',
    '963', '964', '969', '970', '981', '982', '990',
];
const DATENSTROM_2025 = {
    year: 2025,
    schemaFile: 'datenstrom/2025/BMF_XSD_Jahreserklaerungen_2025.xsd',
    schemaStand: '2025-11-21',
    u1: U1_2025,
    e1: { selbstaendig: e1Tree('selbstaendig'), gewerbebetrieb: e1Tree('gewerbebetrieb') },
    // The Kleinunternehmerpauschalierung is filed on the Beilage E1a-K with its
    // own set of Kennzahlen (9027/9055/9028); easyrechnung does not write it.
    gewinnermittlung: {
        ea: { flag: 'GWA43', requiredKz: [] },
        // Prüfung E1a: eine Pauschalierung nur mit Kennzahl 9259, 0,00 ist zulässig.
        basis_pauschal: { flag: 'GWA171', requiredKz: ['9259'] },
    },
    staatOesterreich: 'A',
    branchenkennzahlen: BRANCHENKENNZAHLEN_2025,
    branchenkennzahlenUrl: 'https://www.bmf.gv.at/dam/jcr:ac457647-82ea-434f-b24c-cc9e36aeea3f/BMF_Wertevorrat_BRANCHENKENNZAHL_Jahreserklaerung_2025.pdf',
    vstPattern: '^[0-9]{1}[0-9,a-z,A-Z]{1,3}$',
};
/**
 * The structure for `year`, or `null` while the BMF has published none. The
 * structure of an assessment year appears in its following autumn — 2026 has
 * none yet.
 */
export function datenstrom(year) {
    return year === 2025 ? DATENSTROM_2025 : null;
}
//# sourceMappingURL=datenstrom.js.map